import {
  Box,
  FlexBox,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
  Text,
} from '@dixa/lib-shared-habla';

import { CopilotFeaturesRow } from 'app/views/layout/views/settings/views/copilotTrial/components/copilotFeaturesRow/copilotFeaturesRow';
import { createAppModal } from 'utils/modal';
import { useAppNavigate } from 'utils/url/useAppNavigate';
import { useCopilotTrial } from 'utils/useCopilotTrial';

import styles from './copilotTrialIntroModal.module.scss';

export const CopilotTrialIntroModal = createAppModal(
  { type: 'app:copilotTrialIntro' },
  ({ isOpen, hide }): JSX.Element => {
    const { setDismissedIntroModal } = useCopilotTrial();
    const navigate = useAppNavigate();
    const handleClose = (): void => {
      setDismissedIntroModal();
      hide?.();
    };

    const gotoTrialPage = (): void => {
      navigate({ path: '/settings/copilot-trial' });
      setDismissedIntroModal();
      hide?.();
    };

    return (
      <Modal isOpen={isOpen} onClose={handleClose} className={styles.modal}>
        <ModalHead
          title={
            <>
              Introducing Agent Co-pilot:
              <br />
              Elevate Your Support Experience with AI!
            </>
          }
          onClose={handleClose}
        />

        <ModalBody>
          <FlexBox flexDirection="row">
            <FlexBox flex="1 1 341px">
              <Box width="100%" maxWidth="100%" minHeight="208px">
                <iframe
                  style={{ border: 'none' }}
                  width="100%"
                  height="100%"
                  src="https://www.youtube.com/embed/fCU1uPg_cmE?&amp;wmode=opaque"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </Box>
            </FlexBox>
            <FlexBox
              flex="1 1 510px"
              alignItems="center"
              padding="400"
              justifyContent="center"
            >
              <div style={{ textAlign: 'justify' }}>
                <Text.Paragraph>
                  The Agent Co-pilot bundle equips you with AI-powered tools
                  designed to simplify customer interactions. Say goodbye to
                  time-consuming little tasks and hello to smoother
                  conversations. Stay updated with the latest AI advancements,
                  making your job easier and more efficient.
                </Text.Paragraph>
              </div>
            </FlexBox>
          </FlexBox>

          <CopilotFeaturesRow showLearnMore={false} />

          <Text.Paragraph>
            Keen to explore Agent Co-pilot? Discover its capabilities and
            request your lead to activate the trial.
          </Text.Paragraph>
        </ModalBody>

        <ModalFoot confirmName="Learn more" confirmOnClick={gotoTrialPage} />
      </Modal>
    );
  },
);
